import { isValidPhoneNumber } from 'react-phone-number-input'

export const FormBuilderValidations = {
  tel: (value: any) => isValidPhoneNumber(value),
}
